export const toLowerCase = (value) => {
  if (typeof value === 'string') {
    return value.toLowerCase().trim()
  }
  return ''
}

export const toFirstLast = (value) => {
  if (typeof value === 'string') {
    const parts = value.trim().split(' ').filter(Boolean)
    const first = parts.length > 0 ? toLowerCase(parts[0]) : ''
    const last = parts.length > 1 ? toLowerCase(parts[parts.length - 1]) : ''
    return { first, last }
  }
  return { first: '', last: '' }
}

const test = (fn) => (value) => {
  if (typeof value === 'string') {
    return fn(value)
  }
  if (Array.isArray(value)) {
    return value.some(fn)
  }
  return false
}

const equals = (expected, transform = toLowerCase) => (value) => expected === transform(value)

export const anyEquals = (expected, transform = toLowerCase) => test(equals(expected, transform))
